module.exports = __webpack_public_path__ + "img/grzc.857d8d91.svg";